<md-card (click)="openSelector()" class="selected-list" *ngIf="multiple">
  <div class="title">{{ type.value }}</div>
  <ul>
    <li *ngFor="let value of selectedValues">
      {{ value.name }}
    </li>
  </ul>
</md-card>

<div (click)="openSelector()" *ngIf="!multiple" class="selector">
  <label>{{ type.value }}</label>
  <div class="selected" [ngClass]="{ empty: selectedValues.length === 0 }">
    <span *ngIf="selectedValues.length > 0">
      {{ selectedValues[0].name }}
    </span>
  </div>
</div>

<md2-dialog #selection>
  <app-spinner *ngIf="loading"></app-spinner>
  <div class="input">
    <div class="input">
      <md-icon>search</md-icon>
      <md-form-field>
        <input
          mdInput
          name="search"
          placeholder="Search"
          [(ngModel)]="term"
          [autofocus]="true"
        />
      </md-form-field>
    </div>
  </div>
  <div *ngIf="!multiple && selectedValues.length > 0" class="selected-item">
    {{ selectedValues[0].name }}
    <md-icon (click)="clearSelection()">clear</md-icon>
  </div>
  <div class="selection" *ngIf="!loading">
    <div class="items">
      <div
        *ngFor="
          let value of unselectedValues
            | searchByTerm: term:['name', 'id']:updated
            | orderBy: 'lockStatus':'asc':'name'
        "
        (click)="selectValue(value)"
        class="item"
      >
        <md-icon
          class="icon-lock-referential"
          *ngIf="value.lockStatus"
          tooltip="Locked in Chapca"
          >lock</md-icon
        >
        <md-icon class="icon-lock-referential" *ngIf="!value.lockStatus"
          >lock_open</md-icon
        >
        {{ value.name + " - [" + value.id + "]" }}
      </div>
    </div>
    <div class="items" *ngIf="multiple">
      <div
        *ngFor="
          let value of selectedValues | orderBy: 'lockStatus':'asc':'name'
        "
        (click)="unselectValue(value)"
        class="item"
      >
        <md-icon
          class="icon-lock-referential"
          *ngIf="value.lockStatus"
          tooltip="Locked in Chapca"
          >lock</md-icon
        >
        <md-icon class="icon-lock-referential" *ngIf="!value.lockStatus"
          >lock_open</md-icon
        >
        {{ value.name + " - [" + value.id + "]" }}
      </div>
    </div>
  </div>
  <md2-dialog-footer>
    <div class="buttons">
      <button (click)="AddAll()" md-raised-button color="primary">
        Add all
      </button>
      <button (click)="RemoveAll()" md-raised-button color="primary">
        Remove all
      </button>
      <button (click)="close()" md-raised-button color="primary">OK</button>
    </div>
  </md2-dialog-footer>
</md2-dialog>



// WEBPACK FOOTER //
// ./src/app/components/list-selector/list-selector.component.html